import { Flex } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const Container = styled(Flex).attrs({
  flexDirection: "column",
  gap: "xs",
})<{ disabled?: boolean }>`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
  padding: 0 24px 24px 24px;
`;

export const AnimatedContainer = styled(Flex)`
  transition: height 0.3s ease;
  overflow: hidden;
`;
